import "./MemberLogin.module.css";
import Header from "@/reusable_sections/Header";
import Partnership from "./sections/Partnership";
import Footer from "@/reusable_sections/Footer";
export default function MemberLoginPage() {
  return <div>
      <Header />
      <Partnership />
      <Footer />
    </div>;
}